// utils/circuitMapper.ts

export const createCircuitFromRow = (row: string[], index: number, headerMappings: {[key: number]: string}) => {
    const circuit: any = {
        circuitNumber: index,
        circuitId: "",
        description: "",
        maxCurrent: 0,
        continousCurrent: 0,
        wireDimentions: "N/A",
        meteredBy: "",
        driverTypes: 1,
        assetBuildingAutomationId: 0,
        tagId: 0
    };

    // Map each header to its corresponding circuit property
    Object.entries(headerMappings).forEach(([headerIndex, mappingValue]) => {
        const cellValue = row[parseInt(headerIndex)] || "";
        
        switch (mappingValue) {
            case 'circuitId':
                circuit.circuitId = cellValue || `Circuit ${index + 1}`;
                break;
            case 'description':
                circuit.description = cellValue || "";
                break;
            case 'maxCurrent':
                circuit.maxCurrent = parseFloat(cellValue) || 0;
                break;
            case 'continousCurrent':
                circuit.continousCurrent = parseFloat(cellValue) || 0;
                break;
            case 'wireDimentions':
                circuit.wireDimentions = cellValue && cellValue.trim() ? cellValue.trim() : "N/A";
                break;
            case 'meteredBy':
                circuit.meteredBy = cellValue || "";
                break;
            case 'driverTypes':
                circuit.driverTypes = parseInt(cellValue) || 1;
                break;
            case 'assetBuildingAutomationId':
                circuit.assetBuildingAutomationId = parseInt(cellValue) || 0;
                break;
            case 'tagId':
                circuit.tagId = parseInt(cellValue) || 0;
                break;
            case 'ignore':
                break;
        }
    });

    return circuit;
};